"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blurs = void 0;
/* eslint-disable sort-keys */

var blurs = exports.blurs = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '20px'
};